module.exports = __webpack_public_path__ + "img/s1-1-s.ae1a98c1.svg";